import { render } from "./Backend.vue?vue&type=template&id=564fda2e"
import script from "./Backend.vue?vue&type=script&lang=js"
export * from "./Backend.vue?vue&type=script&lang=js"
script.render = render

export default script